import moment from 'moment-timezone';

/**
 * Labels how many hours `offset`'s UTC offset is ahead of `reference`'s, e.g.
 * '+5 hrs', '-1 hr' or '+5.5 hrs'. Undefined when they're the same. Each offset
 * is taken at its own moment, so daylight saving depends on the dates given.
 */
export const calculateOffsetLabel = (
  reference: moment.Moment,
  offset: moment.Moment
) => {
  const hours = (offset.utcOffset() - reference.utcOffset()) / 60;

  if (!hours) {
    return;
  }

  return [
    hours > 0 ? `+${hours}` : hours.toString(),
    `hr${Math.abs(hours) > 1 ? 's' : ''}`,
  ].join(' ');
};
